/**
 * What a route's `handle` may carry. `layout: 'workspace'` switches the shell
 * to the full-height, no-footer mode; `pane` is an opaque marker for a step of
 * a workspace drill-down. Each workspace narrows it with its own guard
 * (`isUsersPane`, `isSpotsPane`), so no domain knowledge lives here.
 */
export interface AppRouteHandle {
    layout?: 'workspace';
    pane?: string;
}

/** Narrows a router match's untyped `handle`. Anything unknown gives `{}`. */
export function routeHandle(match: { handle: unknown }): AppRouteHandle {
    const { handle } = match;
    if (typeof handle !== 'object' || handle === null) return {};

    const result: AppRouteHandle = {};
    if ('layout' in handle && handle.layout === 'workspace') {
        result.layout = 'workspace';
    }
    if (
        'pane' in handle &&
        typeof handle.pane === 'string' &&
        handle.pane !== ''
    ) {
        result.pane = handle.pane;
    }
    return result;
}
